/** Uploading files to a project, from the QAgent home and project chat */
export const projectUploads = {
  dialog: {
    title: (count: number) => (count === 1 ? 'Uploading file…' : `Uploading ${count} files…`),
    progress: (done: number, total: number) => `${done} of ${total} done`,
    waiting: 'Waiting',
    uploaded: 'Uploaded',
    failed: 'Failed',
    closeHint: 'You can close this. The upload carries on, and you get a message when it ends.',
  },
  toasts: {
    uploadedOne: (name: string) => `"${name}" uploaded`,
    uploadedMany: (count: number) => `${count} files uploaded`,
    failedOne: (name: string) => `Could not upload "${name}"`,
    failedSome: (failed: number, total: number) =>
      failed === total
        ? `None of the ${total} files could be uploaded`
        : `${failed} of ${total} files could not be uploaded`,
    skippedType: 'Skipped: only PDF, Word, text and Markdown files can be added',
    skippedSize: (mb: number) => `Skipped: files can be at most ${mb} MB`,
    skippedEmpty: 'Skipped: empty files and folders cannot be added',
    skippedCount: (max: number) => `Skipped: up to ${max} files can be added at a time`,
    busy: 'Wait for the current upload to finish',
    noneAdded: 'None of these files can be added',
  },
  /** Why a file was skipped, before its name, under another toast */
  skippedReason: {
    type: 'Skipped (only PDF, Word, text and Markdown)',
    size: (mb: number) => `Skipped (over ${mb} MB)`,
    empty: 'Skipped (empty file or folder)',
    count: (max: number) => `Skipped (more than ${max} at a time)`,
  },
  errors: {
    tooLarge: (mb: number) => `The file is larger than ${mb} MB`,
    generic: 'The upload failed',
  },
};

export type ProjectUploadsDict = typeof projectUploads;
